import { Link } from "react-router-dom";

interface MangaCardProps {
  id: number;
  title: string;
  author: string;
  description: string;
  chapters: number;
  status: string;
  rating: number;
  views: string;
  updateTime: string;
  imageUrl: string;
  imageUrlThumb: string;
  variant?: "default" | "featured" | "daily";
}

export default function MangaCard({
  id,
  title,
  author,
  description,
  chapters,
  status,
  rating,
  views,
  updateTime,
  imageUrl,
  imageUrlThumb,
  variant = "default",
}: MangaCardProps) {
  if (variant === "featured") {
    return (
      <Link
        to={`/article/${id}`}
        className="group relative overflow-hidden rounded-lg aspect-[3/4] block cursor-pointer"
        data-product-shop=""
      >
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 漫蛙免费漫画在线阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
          <h3 className="text-white font-heading text-lg md:text-xl mb-1">{title}</h3>
          <p className="text-white/70 text-xs md:text-sm line-clamp-1">{description}</p>
        </div>
        <div className="absolute top-3 right-3 bg-primary-500 text-white text-xs px-2 py-1 rounded-md font-medium">
          {rating}
        </div>
      </Link>
    );
  }

  if (variant === "daily") {
    return (
      <Link
        to={`/article/${id}`}
        className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
        data-product-shop=""
      >
        <div className="flex items-start gap-1 px-3 py-2 border-b border-background-100">
          <span className="text-xs text-accent-600 font-medium flex items-center gap-1">
            <i className="ri-time-line"></i>
            {updateTime}
          </span>
          <span className="text-xs text-foreground-400 ml-auto">{chapters}话</span>
        </div>
        <div className="p-3 flex flex-col items-center">
          <div className="w-32 h-44 rounded-md overflow-hidden mb-3">
            <img
              src={imageUrlThumb}
              alt={title}
              title={`${title} - 漫蛙免费漫画在线阅读`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <h4 className="text-sm font-medium text-foreground-950 text-center mb-1">{title}</h4>
          <p className="text-xs text-foreground-500">{author}</p>
        </div>
        <div className="px-3 pb-3">
          <span className="block w-full py-2 bg-background-100 group-hover:bg-accent-500 group-hover:text-white text-foreground-700 text-xs text-center rounded-md transition-colors cursor-pointer whitespace-nowrap">
            {status === "连载中" ? "继续阅读" : "开始阅读"}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      data-product-shop=""
    >
      <div className="aspect-[3/4] overflow-hidden relative">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 漫蛙免费漫画在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-2 right-2 bg-background-50/90 text-foreground-950 text-xs px-2 py-1 rounded-md font-medium">
          {rating}
        </div>
        {status === "已完结" && (
          <div className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-1 rounded-md">
            完结
          </div>
        )}
      </div>
      <div className="p-3">
        <h4 className="text-sm font-medium text-foreground-950 mb-1">{title}</h4>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{author}</span>
          <span className="text-xs text-foreground-400">{views}</span>
        </div>
      </div>
    </Link>
  );
}